import React, {useEffect, useRef, useState} from 'react';
import {withRouter} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {findDirectoryGroups} from '../../../actions/directoryGroupActions';
import {findSystemGroups} from '../../../actions/systemGroupActions';
import {
	findLabels,
	findLabelsByType,
	getEnteredSearchValue as setEnteredSearchValue,
	getSelectedContactsGroup, resetStates
} from '../../../actions/contactsGroupItemActions';
import {enteredCollaboratorSearchValue, getSharingDetailsPopup} from '../../../actions/sharingDetailsActions';
import {isAnsweredChromeExtInstallRequest, sharingPageReady as setSharingPageReady} from '../../../actions/profileActions';
import {isDragging as setIsDragging} from '../../../actions/dragNDropActions';
import {postContactsAdvancedSearch, findContacts, selectedContacts} from '../../../actions/contactActions';
import ListOfContacts from './components/list-of-contacts';
import SharingDetailsPopup from './components/sharing-details-popup';
import SuspiciousDeletedContactsPopup from '../../components/popup/components/suspicious-deleted-contacts-popup';
import SharingDetailsLv2Popup from './components/sharing-details-lv2-popup';
import GmailAddOnShareFromMarketPlace
	from './components/sharing-details-popup/components/gmail-add-on-share-from-market-place';
import ListOfGroups from './components/list-of-groups';
import ListOfContactsPreview from './components/list-of-contacts-preview';
import DragInfo from '../../components/drag-info';
import ContactDetails from './components/contact-details';
import NewContactPopup from "./components/sharing-details-popup/components/new-contact-popup";
import {findContactDetails, resetFindContactDetails} from '../../../actions/contactDetailsActions';
import FlashMessage from '../../components/flash-message';
import Button from '../../components/button';
import {postEngagement} from '../../../actions/engagementActions';
import Loader from '../../components/sprite/components/loader';
import {generateId, normalizeCriteriaValue, urlOperatorToString} from '../../utils';
import {advanceSearchCriteria} from '../../../actions/advanceSearchActions';
import AsideCard from './components/aside-card';
import ContactsHistoryLogs from './components/contacts-history-logs';
import GmailAddonAd from './components/gmail-addon-ad';
import './index.css';

function Sharing (props) {

	let { location, history } = props;

	const enteredSearchValue = useSelector(state => state.contactsGroupItemReducer.getEnteredSearchValue);
	const filteredStatus = useSelector(state => state.contactsGroupItemReducer.getFilteredStatus);
	const labelsPageSize = useSelector(state => state.contactsGroupItemReducer.labelsPageSize);
	const profile = useSelector(state => state.profileReducer.getProfile);
	const getContactCardDetails = useSelector(state => state.contactReducer.contactCardDetails);
	const sharingPageReady = useSelector(state => state.profileReducer.sharingPageReady);
	const isDragging = useSelector(state => state.dragNDropReducer.isDragging);
	const checkGmailAddOnFromMarketPlace = useSelector(state => state.profileReducer.checkGmailAddOnFromMarketPlace);
	const checkGmailAddOnData = useSelector(state => state.profileReducer.setGmailAddOnData);
	const isLabelSelectedOnMobile = useSelector(state => state.mobileReducer.isLabelSelectedOnMobile);
	const suspiciousContactsDeletion = useSelector(state => state.suspiciousContactsDeletionReducer.fetchSuspiciousContactsDeletion);
	const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);
	const contactDetails = useSelector(state => state.contactDetailsReducer.findContactDetails);
	const directoryGroups = useSelector(state => state.directoryGroupReducer.findDirectoryGroups);
	const systemGroups = useSelector(state => state.systemGroupReducer.findSystemGroups);
	const labels = useSelector(state => state.contactsGroupItemReducer.findLabels);
	const contactsPageSize = useSelector(state => state.contactReducer.contactsPageSize);
	const userContactType = useSelector(state => state.contactReducer.userContactType);
	const flash = useSelector(state => state.sharingDetailsReducer.flash);

	const dispatch = useDispatch();
	const {t} = useTranslation();

	let labelFound = useRef(false);

	const [isAsideCollapsed, setIsAsideCollapsed] = useState(false);

	useEffect(() => {
		dispatch(setSharingPageReady(true));
	}, [dispatch]);

	useEffect(() => {
		if(!directoryGroups){
			dispatch(findDirectoryGroups());
		}
	}, [dispatch, directoryGroups]);

	useEffect(() => {
		if(!systemGroups){
			dispatch(findSystemGroups());
		}
	}, [dispatch, systemGroups]);

	useEffect(() => {
		if (labels) return;

		if (filteredStatus) {
			if (enteredSearchValue !== '') {
				dispatch(findLabelsByType(filteredStatus));
			} else {
				dispatch(findLabelsByType(filteredStatus, labelsPageSize));
			}
		} else {
			if (enteredSearchValue !== '') {
				dispatch(findLabels());
			} else {
				dispatch(findLabels(labelsPageSize));
			}
		}
	}, [
		dispatch,
		labels,
		filteredStatus,
		enteredSearchValue,
		labelsPageSize
	]);

	useEffect(() => {

		let checkContactCard = true;

		if(!sharingPageReady){
			dispatch(setEnteredSearchValue(''));
			dispatch(enteredCollaboratorSearchValue(''));
		}

		if (profile) {
			if (window.localStorage.getItem('whoAnsweredChromeExtInstallRequest') === profile.id) {
				dispatch(isAnsweredChromeExtInstallRequest(true));
			}
		}

		/*
		* Gmail Addon
		* */

		if (Object.keys(getContactCardDetails).length > 1 && sharingPageReady && checkContactCard) {
			let arrContactId = [];
			if (getContactCardDetails?.commentId) {
				arrContactId[0] = {id: getContactCardDetails.contactId, type: 'contact'};
				dispatch(getSharingDetailsPopup([true, 'contact_details', arrContactId]));
				checkContactCard = false;
			} else {
				checkContactCard = false;
			}
		}

	}, [dispatch, profile, sharingPageReady, getContactCardDetails]);

	/*
	* Select directory and sub-directory label related on label id from URL
	**/

	useEffect(() => {
		if(location.pathname.includes('/label/')){

			if (directoryGroups) {
				const checkAndDispatch = (item) => {
					if (item.rootOu.id === location.pathname.split('/label/')[1]) {
						dispatch(getSelectedContactsGroup({
							'id': item.rootOu.id,
							'name': item.rootOu.name,
							'status': item.rootOu.status,
							'permission': item.rootOu.permission,
							'type': "directory",
							'activeDirectory': item.activeDirectory,
							'ownerId': item.rootOu.ownerId,
							'ownerName': item.rootOu.ownerName,
							'index': item.rootOu.index,
							'directorySyncType': item.directorySyncType,
							'directorySyncStatus': item.directorySyncStatus,
							'directoryDisplayStatus': item.directoryDisplayStatus,
							'customerId': item.customerId
						}));

						dispatch(findContacts(item.rootOu.id, contactsPageSize));
						labelFound.current = true;
						return true;
					}

					if (item.rootOu.childOu.length > 0) {
						for (const childOuItem of item.rootOu.childOu) {
							if (childOuItem.id === location.pathname.split('/label/')[1]) {
								dispatch(getSelectedContactsGroup({
									'id': childOuItem.id,
									'name': childOuItem.name,
									'status': childOuItem.status,
									'permission': childOuItem.permission,
									'type': "childDirectory",
									'activeDirectory' : item.activeDirectory,
									'ownerId': childOuItem.ownerId,
									'ownerName': childOuItem.ownerName,
									'parentId' : childOuItem.parentId,
									'parentName' : childOuItem.parentName,
									'index': childOuItem.index,
									'ouSharingPermission' : childOuItem.ouSharingPermission,
									'ouSharingState' : childOuItem.ouSharingState
								}));

								dispatch(findContacts(childOuItem.id, contactsPageSize));
								labelFound.current = true;
								return true;
							}

							if (childOuItem.childOu.length > 0) {
								for (const childOuItemLv2 of childOuItem.childOu) {
									if (childOuItemLv2.id === location.pathname.split('/label/')[1]) {
										dispatch(getSelectedContactsGroup({
											'id': childOuItemLv2.id,
											'name': childOuItemLv2.name,
											'status': childOuItemLv2.status,
											'permission': childOuItemLv2.permission,
											'type': "childDirectoryLv2",
											'activeDirectory' : item.activeDirectory,
											'ownerId': childOuItemLv2.ownerId,
											'ownerName': childOuItemLv2.ownerName,
											'parentId' : childOuItem.parentId,
											'parentName' : childOuItem.parentName,
											'index': childOuItemLv2.index,
											'ouSharingPermission' : childOuItemLv2.ouSharingPermission,
											'ouSharingState' : childOuItemLv2.ouSharingState
										}));

										dispatch(findContacts(childOuItemLv2.id, contactsPageSize));
										labelFound.current = true;
										return true;
									}
								}
							}
						}
					}

					return false;
				};

				directoryGroups.directoryContactGroupsV4.some(item => checkAndDispatch(item));
			}
		}
	}, [dispatch, location, contactsPageSize, directoryGroups]);

	/*
	* Force selecting system label
	**/

	useEffect(() => {
		if(systemGroups
			&& !selectedContactsGroup
			&& !location.pathname.includes('/label/')
			&& !location.pathname.includes('/contact/')
			&& !location.pathname.includes('/contacts/search')
		){
			history.push(`/label/${systemGroups.systemGroups[0].id}-${systemGroups.systemGroups[0].ownerId}`);
		}
	}, [history, systemGroups, selectedContactsGroup, location]);

	/*
	* Select system label related on label id from URL
	**/

	useEffect(() => {
		if(location.pathname.includes('/label/')){
			if(systemGroups){
				systemGroups.systemGroups.forEach(item => {
					if(`${item.id}-${item.ownerId}` === location.pathname.split('/label/')[1]){
						dispatch(getSelectedContactsGroup({
							'id' : item.id,
							'name' : item.name,
							'status' : item.status,
							'permission' : item.permission,
							'type' : "system",
							'activeDirectory' : item.activeDirectory,
							'ownerId': item.ownerId,
							'ownerName': item.ownerName,
							'index': item.index,
							'directorySyncType': item.directorySyncType,
							'directorySyncStatus': item.directorySyncStatus,
							'directoryDisplayStatus': item.directoryDisplayStatus,
							'customerId': item.customerId
						}));

						dispatch(findContacts(6, contactsPageSize));
						labelFound.current = true;
					}
				})
			}
		}
	}, [dispatch, location, contactsPageSize, systemGroups]);

	/*
	* Select contact label related on label id from URL
	**/

	useEffect(() => {
		if(location.pathname.includes('/label/')){
			if(labels){
				labels.contactsGroups.forEach(item => {
					if(item.id === location.pathname.split('/label/')[1]){
						dispatch(getSelectedContactsGroup({
							'id' : item.id,
							'name' : item.name,
							'status' : item.status,
							'permission' : item.permission,
							'type' : "contact",
							'activeDirectory' : item.activeDirectory,
							'ownerId': item.ownerId,
							'ownerName': item.ownerName,
							'index': item.index,
							'directorySyncType': item.directorySyncType,
							'directorySyncStatus': item.directorySyncStatus,
							'directoryDisplayStatus': item.directoryDisplayStatus,
							'customerId': item.customerId
						}));

						dispatch(findContacts(item.id, contactsPageSize));
						labelFound.current = true;
					}
				})
			}
		}
	}, [dispatch, location, labels, contactsPageSize]);

	/*
	* Reset some data on location change
	* */

	useEffect(() => {
		if(location.pathname.includes('/label/')) {
			dispatch(resetFindContactDetails());
			dispatch(resetStates());
		}
	}, [dispatch, location]);

	/*useEffect(() => {
		if(isMobileOrTabletDetected){
			if(location.pathname.includes('/label/') || location.pathname.includes('/contact/')) {
				dispatch(setIsLabelSelectedOnMobile(true));
			}
		}
	}, [dispatch, location, isMobileOrTabletDetected]);*/

	/*
	* Active label from URL or Already selected label
	**/

	useEffect(() => {
		if(selectedContactsGroup) {
			document.querySelectorAll('.list-of-groups .label').forEach( item => {
				if(location.pathname.includes('/label/')){
					if(item.id === location.pathname.split('/label/')[1]){
						item.classList.add('active')
					} else {
						item.classList.remove('active')
					}
				} else {
					if(item.dataset.type === 'system'){
						if(item.id === selectedContactsGroup.id + '-' + selectedContactsGroup.ownerId){
							item.classList.add('active')
						} else {
							item.classList.remove('active')
						}
					} else {
						if(item.id === selectedContactsGroup.id){
							item.classList.add('active')
						} else {
							item.classList.remove('active')
						}
					}
				}
			})
		} else {
			document.querySelectorAll('.list-of-groups .label').forEach( item => {
				item.classList.remove('active')
			})
		}
	}, [location, selectedContactsGroup]);

	useEffect(() => {
		if(location.pathname.includes('/contact/')) {
			dispatch(resetStates());

			if (/^\d{21}$/.test(location.pathname.split('/')[2])) {
				dispatch(findContactDetails(location.pathname.split('/')[2], "user"));
			} else {
				dispatch(findContactDetails(location.pathname.split('/')[2], userContactType));
			}

		}
	}, [dispatch, location, selectedContactsGroup, userContactType]);

	/*
	* If the user leave the sharing page
	* */
	useEffect(() => {
		return () => {
			dispatch(getSelectedContactsGroup(null));
		}
	}, [dispatch]);

	/*
	* On URL path advanced search show results
	* */

	useEffect(() => {
		if (location.pathname.includes('/contacts/search') && location.search.includes('?q=')) {
			const advanceSearchString = location.search.split('=')[1];
			let criteriaArray = [];
			if (advanceSearchString.includes(';')) {
				criteriaArray = advanceSearchString.split(';')
			} else {
				criteriaArray.push(advanceSearchString)
			}

			const operators = [
				"!=null",
				"=null",
				"!~",
				"~",
				">>",
				"<<",
				">",
				"<",
				"="
			].map(op => encodeURIComponent(op));

			let searchParamsArray = [];

			criteriaArray.forEach(criteriaItem => {
				const matchedOperator = operators.find(op => criteriaItem.includes(op));

				if (matchedOperator) {

					const parts = criteriaItem.split(matchedOperator);

					let field = parts[0];
					let rawValue = parts[1];

					const { value: normalizedValue, error } = normalizeCriteriaValue(field, rawValue);

					searchParamsArray.push({
						id: generateId(),
						field,
						operator: urlOperatorToString(matchedOperator),
						value: normalizedValue,
						error
					})

				}
			});

			dispatch(advanceSearchCriteria(searchParamsArray));

			dispatch(postContactsAdvancedSearch({
				populated: true,
				searchParams: searchParamsArray
			}, 50));

		}
	}, [dispatch, location]);


	const handleUpgrade = () => {
		dispatch(postEngagement(59, new Intl.DateTimeFormat('fr-FR', {
			day: '2-digit',
			month: '2-digit',
			year: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit',
		}).format()));
	};

	const mouseUpAndLeaveHandler = () => {
		if (isDragging) {
			dispatch(setIsDragging(false));
			document.querySelectorAll('.drag-n-drop').forEach(item => item.classList.contains('drag-n-drop') ? item.classList.remove('drag-n-drop') : null);
			document.querySelector('.sharing').style.cursor = 'default';
			dispatch(selectedContacts([]));
			document.querySelectorAll('.contact .custom-control-input').forEach(item => item.checked = false);
		} else {
			document.querySelector('.sharing').style.cursor = 'default';
		}
	};

	const calendlyWidget = () => {
		window.Calendly.initPopupWidget({
			url: 'https://calendly.com/sidgar/15min',
			text: 'Book a Live Demo',
			color: '#00a2ff',
			textColor: '#ffffff',
			branding: true
		});
	};

	let checkLocalStorage = localStorage.getItem('gmailAddOnFromMarketPlace');

	const collapseAside = () => {
		setIsAsideCollapsed(!isAsideCollapsed);
	}

	if (checkGmailAddOnData.action === 'addToAContact') {
		return (
			<ListOfContacts/>
		)
	} else {
		return (
			<div
				className={`sharing${isLabelSelectedOnMobile ? ' selected-label-on-mobile' : ''}${isAsideCollapsed ? ' aside-collapsed' : ''}`}
				onMouseUp={mouseUpAndLeaveHandler}
				onMouseLeave={mouseUpAndLeaveHandler}
			>
				{
					(
						suspiciousContactsDeletion?.totalNoOfContactsAdminNeededToReviewOn > 0
						||
						suspiciousContactsDeletion?.totalNoOfContactsNeededToActionOn > 0
						||
						suspiciousContactsDeletion?.totalNoOfContactsOwnerNeededToReviewOn > 0
					) && <SuspiciousDeletedContactsPopup/>
				}
				<SharingDetailsLv2Popup/>
				{checkGmailAddOnFromMarketPlace || checkLocalStorage ?
					<GmailAddOnShareFromMarketPlace/> : ''}
				<SharingDetailsPopup/>
				{
					flash && <FlashMessage type={flash.type} message={flash.message}/>
				}
				<ListOfGroups/>
				{
					location.pathname.includes('/label/new-contact') && <div className="new-contact-wrapper">
						<NewContactPopup/>
					</div>
				}
				{
					location.pathname.includes('/contact/')
					&&
					(
						contactDetails
						?
							contactDetails.id
							?
								<ContactDetails/>
							:
								<div className="p-3">
									Contact not found!
								</div>
						:
							<div className='p-3'>
								<Loader />
							</div>
					)
				}
				{
					location.pathname.includes('/label') && location.pathname !== '/label/new-contact' && location.pathname !== '/label/latest-contacts' &&
					(
						selectedContactsGroup
						?
							(
								selectedContactsGroup.type === 'directory'
								|| selectedContactsGroup.type === 'childDirectory'
								|| selectedContactsGroup.type === 'childDirectoryLv2'
							)
							?
								// Directory not possessed yet.
								selectedContactsGroup.activeDirectory === false
								?
									<ListOfContactsPreview/>
								:
									// Your activated Directory label OR one shared to the user
									(profile.isAdmin || selectedContactsGroup.status === 'SHARED_WITH_ME')
									&&
									(
										profile.domain?.plan === 'FREE_EDITION'
										|| profile.domain?.plan === 'BUSINESS'
										|| profile.domain?.plan === 'CORPORATE'
										|| profile.domain?.status === 'EVAL'
										|| profile.domain?.status === 'INVITED'
									)
									?
										<ListOfContacts/>
									:
										<ListOfContactsPreview/>
							:
								<ListOfContacts/>
						:
							systemGroups && labels && directoryGroups && labelFound.current === false
							?
								<div className='p-3'>
									This label doesn't exist.
								</div>
							:
								<div className='p-3'>
									<Loader/>
								</div>
					)
				}
				{
					location.pathname.includes('/contacts/search')
					&& <ListOfContacts/>
				}
				{
					location.pathname === "/label/latest-contacts"
					&& <ContactsHistoryLogs/>
				}
				{
					location.pathname === "/" &&
						<div className='p-3'>Select a label</div>
				}
				{
					isAsideCollapsed
					&&
					<><Button onClick={ collapseAside } className="mb-2 p-0" style={{width: 32, height: 32, zIndex: 1, position: 'absolute', right: 0, top: '50%', backgroundColor: '#fff', borderRadius: '100% 0 0 100%', boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'}}>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
							 xmlSpace="preserve"><path fill="#757575" d="m10.2 12 9.201 9.199-2.8 2.801-12-12 12-12 2.8 2.801z"/></svg>
					</Button></>
				}
				<aside>
					{
						!isAsideCollapsed
						&&
							<><Button onClick={ collapseAside } className="mb-2 p-0" style={{width: 32, height: 32, zIndex: 1, position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)', backgroundColor: '#fff', borderRadius: '0 100% 100% 0', boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'}}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
									 xmlSpace="preserve"><path fill="#757575" d="M13.801 12 4.6 2.8 7.4 0l12 12-12 12-2.8-2.801z"/></svg>
							</Button>
							{/*<Button onClick={ collapseAside } className="mb-2 p-0" style={{width: 32, height: 32, zIndex: 1, position: 'relative', left: '-2em', top: '-1em', backgroundColor: '#fff', borderRadius: '100% 0 0 100%', boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'}}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
									xmlSpace="preserve"><path fill="#757575" d="m10.2 12 9.201 9.199-2.8 2.801-12-12 12-12 2.8 2.801z"/></svg>
							</Button>*/}</>
					}
					<AsideCard>
						<h2>
							{t('bookDemoTitle')}
						</h2>
						<p>
							{t('bookDemoContent')}
						</p>
						<Button
							title={t("headerBookDemoCall")}
							aria-label={t("headerBookDemoCall")}
							className="btn-primary d-flex align-items-center justify-content-center"
							onClick={calendlyWidget}
						>
							<span className="text-truncate">{t("bookDemoBtn")}</span>
						</Button>
					</AsideCard>
					{
						profile && ((profile?.domain?.plan !== "BUSINESS" || profile?.domain?.status !== "PAID")
							&& (profile?.inviter?.plan !== "BUSINESS" || profile?.inviter?.status !== "PAID"))
						&& ((profile?.domain?.plan !== "BUSINESS" || profile?.domain?.status !== "EXPIRED_PAID")
							&& (profile?.inviter?.plan !== "BUSINESS" || profile?.inviter?.status !== "EXPIRED_PAID"))
						&& <div className="text-center">
							<Button aria-label={t('upgradeToBusinessBtn')} title={t('upgradeToBusinessBtn')} onClick={handleUpgrade}
									className="btn-promo upgrade-to-business-button d-flex align-items-center justify-content-center">
								<svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" className="mr-2">
									<path fill="currentColor"
										  d="M4.61 23.81v-2.95h14.77v2.95zm5.91-5.91V5.83l-3.84 3.8-2.07-2.07L11.99.18l7.38 7.38-2.07 2.07-3.84-3.8V17.9h-2.95z"/>
								</svg>
								<span className="text-truncate">{t('upgradeToBusinessBtn')}</span>
							</Button>
						</div>
					}
					<GmailAddonAd/>
				</aside>
				{
					isDragging ? <DragInfo/> : null
				}

			</div>
		);
	}
}

export default withRouter(Sharing);
